/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { NavigationExtras } from '@angular/router';
import { SNACKBAR_NOTIFICATION_TYPE } from '@core/constants';
import { createAction, props } from '@ngrx/store';

export const showNotification = createAction(
  'Show Notification',
  props<{ data: { message: string; type?: SNACKBAR_NOTIFICATION_TYPE; duration?: number } }>()
);

export const routerNavigate = createAction(
  '[Router] Navigate',
  props<{ commands: any[]; extras?: NavigationExtras }>()
);

export const checkTokenValidity = createAction('Check JWT token validity');
